import { ReviewType } from 'src/app/model/enums/reviewType';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ReviewInterface } from 'src/app/model/reviews/review-interface';
import { ReviewService } from 'src/app/services/review-service/review.service';
import { UtilService } from 'src/app/services/util-service/utilService';

@Component({
    selector: 'app-public-review',
    templateUrl: './public-review.component.html',
    styleUrls: ['./public-review.component.css'],
    standalone: false
})
export class PublicReviewComponent implements OnInit {
    reviewTypeEnum = ReviewType;
    private readonly showInitialLinesAmount: number = 4;


    @Input()
    public review: ReviewInterface;

    constructor(private router: Router,
        private reviewService: ReviewService,
        private utilService: UtilService,
    ) { }

    ngOnInit() {
    }

    ngOnChanges(): void {
        this.setHasLongDescriptionForReview();

    }

    /* Navigates to the ProductPage of the given ProductId */
    public navigateToProduct(productId: number) {
        this.router.navigate(['marktplatz', 'products', productId]);
        window.scrollTo(0, 0);
    }

    /* Navigates to the OrganisationPage of the given Organisationname */
    public navigateToOrganisation(orgaName: string) {
        this.router.navigate(['@' + orgaName]);
        window.scrollTo(0, 0);
    }

    private setHasLongDescriptionForReview(): void {
        if (this.utilService.containsTooManyParagraphs(this.review.reviewText, this.showInitialLinesAmount)) {
            this.review.hasLongDescription = true;
            this.review.showComplete = false;
            this.review.shortReviewText = this.utilService.generateShortReviewText(
                this.review.reviewText, this.showInitialLinesAmount
            );
        } else {
            this.review.hasLongDescription = false;
            this.review.showComplete = true;
        }
    }
}
